/*eslint-disable*/

import React, { useEffect } from "react";
import Slider from "react-slick";
import "../../Assests/Globalcss/stylesheet.css";
// import products from '../../services/products'
// import soothing from "../../Assests/Globalimages/nature1 (10).png";
import arrival_bloom1 from "../../Assests/Globalimages/bloom (1).png";
import arrival_bloom2 from "../../Assests/Globalimages/bloom (2).png";
import Navbar from "../../Componenets/Navbar";
import Footer from "../../Componenets/Footer";


import { useNavigate , useLocation } from "react-router-dom";
import ProductCard from "../../Componenets/ProductCard/ProductCard";
import Pagination from "../../Componenets/Pagination/Pagination";
import { fetchProducts } from "../../Redux/Products/productSlice";
import { useDispatch, useSelector } from "react-redux";

const index = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let search = useLocation()?.state?.search;


  useEffect(()=>{
    dispatch(fetchProducts({page : 1 , limit : 1000 , search : search}))
  },[search]);

  const {products} = useSelector((state)=> state.products);


  const filteredProducts = products.filter((item) =>{ 
    if(search?.length > 0){
      return item?.name?.toLowerCase().includes(search)
    }
    else{
      return item
    }
  }
  );
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Runs once when the component mounts
  
  return (
<div >

      <section class="shope-now-section">
        <div class="container">
          <div class="row d-flex justify-content-center align-items-center">
            <div class="col-lg-8">
              <div class="content-shop-now text-center">
                <h3>Shop now </h3>
                <h1>Glow Naturally – Shop Skincare That Loves You Back </h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="Arrival_section">
        <div class="container">
          <div class="row row-gap-5">
            <div class="shope_now mb-0">
              <img src={arrival_bloom2} alt="" />
              <h4 style={{display:'flex', justifyContent:'start', textAlign:'start'}}>SHOP</h4>
              <img src={arrival_bloom1} alt="" />
            </div>

            <div class="shope_noww mb-0">
            <h4 style={{fontSize:17, fontWeight:600}}>SHOWING ALL RESULTS</h4>
            <div class="shope_now mb-0">
             
              <h4 style={{fontSize:17, fontWeight:600}}>DEFAULT SORTING</h4>
              <i class="fa-solid fa-caret-down"></i>
               </div>
             
            </div>

            {filteredProducts?.map((product) => (
             <ProductCard product={product} /> 
            ))}
            {/* <Pagination/> */}
            {/* <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="small_soap_text">
                <div class="sale_card">
                  <div>
                    <i class="fa-solid fa-bag-shopping"></i>
                  </div>
                  <img src={card1} alt="" />
                </div>
                <p>All-Around Safe Block Essence Sun SPF45+</p>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <div>
                  <button onClick={() => navigate("/Cart")}>
                    Add to Cart{" "}
                  </button>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="small_soap_text">
                <div class="sale_card sale_card1">
                  <div>
                    <i class="fa-solid fa-bag-shopping"></i>
                  </div>
                  <img src={card2} alt="" />
                </div>
                <p>All-Around Safe Block Essence Sun SPF45+</p>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <div>
                  <button onClick={() => navigate("/Product")}>
                    Add to Cart{" "}
                  </button>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="small_soap_text">
                <div class="sale_card sale_card2">
                  <div>
                    <i class="fa-solid fa-bag-shopping"></i>
                  </div>
                  <img src={card3} alt="" />
                </div>
                <p>All-Around Safe Block Essence Sun SPF45+</p>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <div>
                  <button onClick={() => navigate("/Product")}>
                    Add to Cart{" "}
                  </button>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="small_soap_text">
                <div class="sale_card sale_card3">
                  <div>
                    <i class="fa-solid fa-bag-shopping"></i>
                  </div>
                  <img src={card4} alt="" />
                </div>
                <p>All-Around Safe Block Essence Sun SPF45+</p>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <div>
                  <button onClick={() => navigate("/Product")}>
                    Add to Cart{" "}
                  </button>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="small_soap_text">
                <div class="sale_card">
                  <div>
                    <i class="fa-solid fa-bag-shopping"></i>
                  </div>
                  <img src={card1} alt="" />
                </div>
                <p>All-Around Safe Block Essence Sun SPF45+</p>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <div>
                  <button onClick={() => navigate("/Cart")}>
                    Add to Cart{" "}
                  </button>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="small_soap_text">
                <div class="sale_card sale_card1">
                  <div>
                    <i class="fa-solid fa-bag-shopping"></i>
                  </div>
                  <img src={card2} alt="" />
                </div>
                <p>All-Around Safe Block Essence Sun SPF45+</p>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <div>
                  <button onClick={() => navigate("/Product")}>
                    Add to Cart{" "}
                  </button>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="small_soap_text">
                <div class="sale_card sale_card2">
                  <div>
                    <i class="fa-solid fa-bag-shopping"></i>
                  </div>
                  <img src={card3} alt="" />
                </div>
                <p>All-Around Safe Block Essence Sun SPF45+</p>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <div>
                  <button onClick={() => navigate("/Product")}>
                    Add to Cart{" "}
                  </button>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="small_soap_text">
                <div class="sale_card sale_card3">
                  <div>
                    <i class="fa-solid fa-bag-shopping"></i>
                  </div>
                  <img src={card4} alt="" />
                </div>
                <p>All-Around Safe Block Essence Sun SPF45+</p>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <div>
                  <button onClick={() => navigate("/Product")}>
                    Add to Cart{" "}
                  </button>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="small_soap_text">
                <div class="sale_card">
                  <div>
                    <i class="fa-solid fa-bag-shopping"></i>
                  </div>
                  <img src={card1} alt="" />
                </div>
                <p>All-Around Safe Block Essence Sun SPF45+</p>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <div>
                  <button onClick={() => navigate("/Cart")}>
                    Add to Cart{" "}
                  </button>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="small_soap_text">
                <div class="sale_card sale_card1">
                  <div>
                    <i class="fa-solid fa-bag-shopping"></i>
                  </div>
                  <img src={card2} alt="" />
                </div>
                <p>All-Around Safe Block Essence Sun SPF45+</p>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <div>
                  <button onClick={() => navigate("/Product")}>
                    Add to Cart{" "}
                  </button>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="small_soap_text">
                <div class="sale_card sale_card2">
                  <div>
                    <i class="fa-solid fa-bag-shopping"></i>
                  </div>
                  <img src={card3} alt="" />
                </div>
                <p>All-Around Safe Block Essence Sun SPF45+</p>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <div>
                  <button onClick={() => navigate("/Product")}>
                    Add to Cart{" "}
                  </button>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="small_soap_text">
                <div class="sale_card sale_card3">
                  <div>
                    <i class="fa-solid fa-bag-shopping"></i>
                  </div>
                  <img src={card4} alt="" />
                </div>
                <p>All-Around Safe Block Essence Sun SPF45+</p>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <div>
                  <button onClick={() => navigate("/Product")}>
                    Add to Cart{" "}
                  </button>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      {/* <section class="email-section">
        <div class="container">
          <div class="newsletter-container">
            <span class="newsletter-text">Subscribe to our newsletter</span>
            <div class="inputs-btn d-flex gap-2">
              <input
                type="email"
                class="newsletter-input"
                placeholder="Your email address..."
              />
              <button class="newsletter-buttone">SUBSCRIBE</button>
            </div>
          </div>
        </div>
      </section> */}
     
      <Footer/>
    </div>
  );
};

export default index;
